<div class="content-layout fullwidth-standard-normal-scroll">
  <div class="header">
    <div class="container">
      <h1>User Profile</h1>
    </div>
  </div>

  <div class="main">
    <div class="flex flex-wrap w-full">
      <div class="flex flex-col w-6/12">
        <div class="flex flex-col p-8 bg-card shadow rounded overflow-hidden mr-4">
          <p class="text-lg font-medium">Profile Details</p>
          <mat-divider class="mt-8 mb-10"></mat-divider>
          <div class="flex flex-col">
            <form [formGroup]="userForm">
              <input [formControlName]="'id'" type="hidden" />
              <div class="avatar-and-name">
                <div class="avatar">
                  <div class="upload">
                    <input
                      id="avatar-file-input"
                      type="file"
                      [multiple]="false"
                      [accept]="'image/jpeg, image/png'"
                      (change)="uploadAvatar(avatarFileInput.files)"
                      #avatarFileInput
                    />
                    <label for="avatar-file-input" matRipple>
                      <mat-icon [svgIcon]="'photo_camera'"></mat-icon>
                    </label>
                  </div>

                  <div class="remove">
                    <button mat-icon-button type="button" (click)="removeAvatar()">
                      <mat-icon [svgIcon]="'delete'"></mat-icon>
                    </button>
                  </div>

                  <img *ngIf="user.avatar_url" [src]="user.avatar_url" />

                  <div class="no-avatar" *ngIf="!user.avatar_url">
                    {{ user.full_name?.charAt(0) }}
                  </div>
                </div>
              </div>
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput [formControlName]="'full_name'" (change)="onNameFieldChange('full_name')" />
                <mat-error *ngIf="userForm.get('full_name').hasError('duplicateName')">
                  Warning: A user with the same name already exists.
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Timezone</mat-label>
                <mat-select [formControlName]="'time_zone'">
                  <mat-option *ngFor="let option of timezoneOptions" [value]="option">
                    {{ option.replaceAll('_', ' ') }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <button
                mat-flat-button
                type="submit"
                [color]="'primary'"
                [disabled]="userForm.invalid || userForm.pristine"
                (click)="updateProfile()"
              >
                Save
              </button>
            </form>
          </div>
        </div>
        <div class="flex flex-col mt-8 p-8 bg-card shadow rounded overflow-hidden mr-4">
          <p class="text-lg font-medium">Update Password</p>
          <mat-divider class="mt-8 mb-10"></mat-divider>
          <div class="flex flex-col">
            <form [formGroup]="resetPasswordForm">
              <input [formControlName]="'id'" type="hidden" />
              <mat-form-field>
                <mat-label>Password</mat-label>
                <input id="password" matInput type="password" [formControlName]="'password'" #passwordField />
                <button
                  mat-icon-button
                  type="button"
                  (click)="
                    passwordField.type === 'password'
                      ? (passwordField.type = 'text')
                      : (passwordField.type = 'password')
                  "
                  tabindex="-1"
                  matSuffix
                >
                  <mat-icon *ngIf="passwordField.type === 'password'" [svgIcon]="'visibility'"></mat-icon>
                  <mat-icon *ngIf="passwordField.type === 'text'" [svgIcon]="'visibility_off'"></mat-icon>
                </button>
                <mat-error> Password is required </mat-error>
              </mat-form-field>

              <!-- Password confirm field -->
              <mat-form-field>
                <mat-label>Password (Confirm)</mat-label>
                <input
                  id="password-confirm"
                  matInput
                  type="password"
                  [formControlName]="'confirm_password'"
                  #passwordConfirmField
                />
                <button
                  mat-icon-button
                  type="button"
                  (click)="
                    passwordConfirmField.type === 'password'
                      ? (passwordConfirmField.type = 'text')
                      : (passwordConfirmField.type = 'password')
                  "
                  tabindex="-1"
                  matSuffix
                >
                  <mat-icon *ngIf="passwordConfirmField.type === 'password'" [svgIcon]="'visibility'"></mat-icon>
                  <mat-icon *ngIf="passwordConfirmField.type === 'text'" [svgIcon]="'visibility_off'"></mat-icon>
                </button>
                <mat-error *ngIf="resetPasswordForm.get('confirm_password').hasError('required')">
                  Password confirmation is required
                </mat-error>
                <mat-error *ngIf="resetPasswordForm.get('confirm_password').hasError('mustMatch')">
                  Passwords must match
                </mat-error>
              </mat-form-field>

              <button
                mat-flat-button
                type="submit"
                [color]="'primary'"
                [disabled]="resetPasswordForm.invalid || resetPasswordForm.pristine"
                (click)="updatePassword()"
              >
                Save
              </button>
            </form>
          </div>
        </div>
        <div class="flex flex-col mt-8 p-8 bg-card shadow rounded overflow-hidden mr-4">
          <p class="text-lg font-medium">Email Signature</p>
          <mat-divider class="mt-8 mb-10"></mat-divider>
          <div>
            <form [formGroup]="signatureForm" style="min-width: 100%">
              <div class="row description">
                <quill-editor [formControlName]="'body'" [modules]="quillModules"></quill-editor>
              </div>
              <div class="reply-form-buttons ml-auto">
                <!-- Actions -->
                <button
                  mat-flat-button
                  type="submit"
                  [color]="'primary'"
                  [disabled]="signatureForm.disabled"
                  (click)="saveSignature()"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="flex flex-col mt-8 p-8 bg-card shadow rounded overflow-hidden mr-4">
          <p class="text-lg font-medium">Email Integration</p>
          <mat-divider class="mt-8 mb-10"></mat-divider>
          <div>
            <treo-card
              class="flex flex-col items-center max-w-80 w-full p-8 filter-info ml-3 mt-3"
              *ngFor="let accountIntegration of accountIntegrations"
            >
              <div class="flex items-center justify-center p-5 rounded-full">
                <img src="assets/images/apps/{{ accountIntegration.integration.slug }}.png" />
              </div>
              <div class="text-2xl font-semibold leading-tight text-center mt-6">
                {{ accountIntegration.integration.name }}
              </div>
              <div class="text-center text-secondary mt-3">
                {{ accountIntegration.integration.description }}
              </div>
              <button
                class="px-6 mt-8"
                mat-flat-button
                [color]="'primary'"
                (click)="connectIntegration(accountIntegration)"
                *ngIf="
                  accountIntegration.user_id
                    ? !(accountIntegration.user_id === user.id && accountIntegration.active)
                    : !accountIntegration.active
                "
              >
                Connect
              </button>
              <button
                class="px-6 mt-8"
                mat-flat-button
                [color]="'primary'"
                (click)="connectIntegration(accountIntegration)"
                *ngIf="
                  accountIntegration.user_id
                    ? accountIntegration.user_id === user.id && accountIntegration.active
                    : accountIntegration.active
                "
              >
                Reconnect
              </button>
            </treo-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
